import { Outlet } from "react-router-dom";

export default function AuthLayout() {
  return (
    <div className="min-h-screen bg-dark-background flex items-center justify-center px-4">
      <div className=" w-[560px] ">
        <div className="bg-dark-background-secondary w-full   rounded-3xl shadow-sm p-4 sm:p-6">
          
          {/* Logo + Brand */}
          <div className="flex items-center gap-3 mb-2">
            <img
              src="/assets/QID-logo.svg"
              className="h-[55px] w-auto"
              alt="QID logo"
            />
          </div>
            
          {/* Child content */}
          <Outlet />
          <p className="mt-2 font-normal text-dark-text text-[12px]">
            Need help? write to <span className="underline">hello@qidworld.com</span>
          </p>
        </div>
      </div>
    </div>
  );
}
